export default __webpack_public_path__ + "ru.7265a3b0.png";